import $ from 'jquery';
import 'slick-carousel';

$(function(){

	objectFitImages('.courseBoxCap img');

	if($(window).width() <= 768){
		$('.sp-menu').on('click',function(){
			$(this).toggleClass('is-active');
			if($(this).hasClass('is-active')){
				$(this).find('img').attr('src', '/assets/img/icon_sp_menu_up.png');
			}else{
				$(this).find('img').attr('src', '/assets/img/icon_sp_menu.png');
			}
			$('.both-area').slideToggle(500);
		});
		$('.comeout-link').on('click',function(){
			$(this).next('.comeout').stop().slideToggle();
			$(this).toggleClass('is-active');
		});
	}else{
		$(".slidein-area").hover(
			function (){
				$(this).find('.comeout').stop().slideDown();
				$(this).find('.comeout-link').addClass('is-active');
			},
			function (){
				$(this).find('.comeout').stop().slideUp();
				$(this).find('.comeout-link').removeClass('is-active');
			}
		);
	}

	$('.top-slide').slick({
    prevArrow: '<img src="/assets/img/arrow_left_brown.png" class="slide-arrow prev-arrow">',
    nextArrow: '<img src="/assets/img/arrow_right_brown.png" class="slide-arrow next-arrow">'
  });


});


// WEBPACK FOOTER //
// ./src/js/renewal.js